import { Auth } from "components/Parts/Organisms/Auth";
import { CheckStickyNotesPage } from "components/Parts/Organisms/CheckStickyNotesPage";
import React from "react";

export const CheckStickyNotes = React.memo(() => (
  <Auth>
    <CheckStickyNotesPage />
  </Auth>
));
